import { render } from "./SubscriberstartCom.vue?vue&type=template&id=57a8b904&scoped=true"
const script = {}

import "./SubscriberstartCom.vue?vue&type=style&index=0&id=57a8b904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a8b904"]])

export default __exports__